<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Food"
};
</script>

<style scoped lang="scss"></style>
